import { LeftOutlined } from '@ant-design/icons'
import { Button, Card, Divider, Flex, Table } from 'antd'
import { useTheme } from 'antd-style'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  usePreScreeningServiceGetRiskGroupEndpoint,
  usePreScreeningServiceGetRiskGroupPersonsEndpoint
} from 'src/api/queries'
import { PageBreadcrumbs, SearchBar, Text } from 'src/components'
import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { resetPagination } from 'src/utils'

import { useCandidateConfig } from '../hooks'
import { useStyles } from '../styles'

export const RiskGroupsCandidatPage = () => {
  const { id } = useParams()

  const navigate = useNavigate()

  const { styles } = useStyles()
  const palette = useTheme()

  const { t } = useLocales()
  const pagination = useTablePagination()

  const [search, setSearch] = useState('')

  const queryParams = {
    riskGroupId: String(id),
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize),
    ...(!!search && {
      searchTerm: search
    })
  }

  const { data, isLoading } = usePreScreeningServiceGetRiskGroupEndpoint({
    id: String(id)
  })

  const { columns, isDeleting } = useCandidateConfig(data)

  const { data: personList, isLoading: isPersonListLoading } =
    usePreScreeningServiceGetRiskGroupPersonsEndpoint(queryParams)

  const onBackClick = () => {
    navigate(paths.riskGroups.root)
  }
  const onSearch = (val: string) => {
    setSearch(val)
    resetPagination(pagination)
  }

  return (
    <PageBreadcrumbs
      title={t('menu.ong_support')}
      items={[
        {
          title: t('menu.ong_support')
        },
        {
          title: String(data?.title)
        }
      ]}
    >
      <Flex vertical gap={16}>
        <Flex justify="space-between" wrap="wrap">
          <Flex vertical className="full-width">
            <Flex gap={16}>
              <Button
                icon={<LeftOutlined />}
                className="fit-content"
                onClick={onBackClick}
              >
                {t('common.back')}
              </Button>
              <SearchBar
                className="full-width"
                placeholder={t('persons.idnp_name_surname_sime_code')}
                onSearch={(val) => onSearch(val)}
              />
            </Flex>
            <Divider />
          </Flex>

          <Flex
            gap={24}
            className="full-width"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between'
            }}
          >
            <Card className={styles.statsCard}>
              <Flex vertical gap={8}>
                <Text color={palette.colorTextDescription}>
                  {t('pre_screening.ong')}
                </Text>
                <Text weight={600}>{data?.title}</Text>
              </Flex>
            </Card>

            <Card className={styles.statsCardSmaller}>
              <Flex vertical gap={8}>
                <Text color={palette.colorTextDescription}>
                  {t('pre_screening.finished_screening')}
                </Text>
                <Text strong>
                  {data?.countPassedPreScreening}{' '}
                  {t('menu.persons').toLocaleLowerCase()}
                </Text>
              </Flex>
            </Card>

            <Card className={styles.statsCardSmaller}>
              <Flex vertical gap={8}>
                <Text color={palette.colorTextDescription}>
                  {t('pre_screening.not_found_screening')}
                </Text>
                <Text strong>
                  {data?.countNotFound} {t('menu.persons').toLocaleLowerCase()}
                </Text>
              </Flex>
            </Card>
          </Flex>
        </Flex>

        <Table
          rowKey={(record) => record?.person?.id}
          scroll={{ x: 'max-content' }}
          columns={columns}
          loading={isLoading || isPersonListLoading || isDeleting}
          dataSource={personList?.data}
          pagination={{ ...pagination, total: data?.totalCount }}
        />
      </Flex>
    </PageBreadcrumbs>
  )
}
